import React, { Component } from "react";

class Tutorials extends Component {
  render() {
    return <div className="home">This is the tutorials div</div>;
  }
}

export default Tutorials;
